/**
 * Marketing + app URLs for SafeVault blog chrome.
 */
const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/safevaultusa/",
  instagram: "https://www.instagram.com/safevault4/",
  facebook: "https://www.facebook.com/profile.php?id=61583243504627",
  twitter: "https://x.com/Safevault125672",
};

function resolveUrlsFromBuildEnv() {
  const landing = (process.env.REACT_APP_LANDING_URL || process.env.REACT_APP_BASE_URL || '').toLowerCase();
  if (!landing) return null;
  if (landing.includes('qa.dev.') || landing.includes('dev.safevault')) {
    return devMarketingUrls();
  }
  if (landing.includes('qa.stage.') || landing.includes('stage.safevault')) {
    return stageMarketingUrls();
  }
  if (landing.includes('safevaultusa.com') && !landing.includes('qa.')) {
    return prodMarketingUrls();
  }
  return null;
}

export function getSafevaultSiteUrls() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();

    if (host.includes("qa.dev.safevaultusa") || host.includes("dev.safevaultusa")) {
      return devMarketingUrls();
    }
    if (host.includes("qa.stage.safevaultusa") || host.includes("stage.safevaultusa")) {
      return stageMarketingUrls();
    }
    if (host.includes("safevaultusa.com")) {
      return prodMarketingUrls();
    }
  }

  return resolveUrlsFromBuildEnv() || devMarketingUrls();
}

function devMarketingUrls() {
  const base = "https://qa.dev.safevaultusa.com";
  const appBase = new URL(process.env.REACT_APP_SIGN_IN_URL || 'https://app.safevaultusa.com/signin').origin;
  return {
    marketingHome: base,
    aboutUs: `${base}/about`,
    products: `${base}/our-products`,
    ourProducts: `${base}/our-products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/tc`,
    privacyPolicy: `${base}/tc`,
    providers: `${base}/providers`,
    appBase,
    login: `${appBase}/login`,
    getStarted: `${appBase}/login?intent=vault`,
    providerLogin: `${appBase}/login?intent=services`,
    signIn: `${appBase}/signin`,
    signUp: `${appBase}/signup`,
    blogHome: "/blog",
    blogPublicUrl: "https://qa.dev.safevaultusa.com/blog",
    cliqloanHome: "https://qa.dev.cliqloan.com",
    safevaultHome: "https://qa.dev.safevaultusa.com",
    amitasoftHome: "https://qa.dev.amitasoft.com",
    social: SOCIAL,
  };
}

function stageMarketingUrls() {
  const base = "https://qa.stage.safevaultusa.com";
  const appBase = "https://stage.safevault.com";
  return {
    marketingHome: base,
    aboutUs: `${base}/about`,
    products: `${base}/our-products`,
    ourProducts: `${base}/our-products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/tc`,
    privacyPolicy: `${base}/tc`,
    providers: `${base}/providers`,
    appBase,
    login: `${appBase}/login`,
    getStarted: `${appBase}/login?intent=vault`,
    providerLogin: `${appBase}/login?intent=services`,
    signIn: `${appBase}/signin`,
    signUp: `${appBase}/signup`,
    blogHome: "/blog",
    blogPublicUrl: "https://qa.stage.safevaultusa.com/blog",
    cliqloanHome: "https://qa.stage.cliqloan.com",
    safevaultHome: "https://qa.stage.safevaultusa.com",
    amitasoftHome: "https://qa.stage.amitasoft.com",
    social: SOCIAL,
  };
}

function prodMarketingUrls() {
  const base = "https://safevaultusa.com";
  const appBase = "https://app.safevaultusa.com";
  return {
    marketingHome: base,
    aboutUs: `${base}/about`,
    products: `${base}/our-products`,
    ourProducts: `${base}/our-products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/tc`,
    privacyPolicy: `${base}/tc`,
    providers: `${base}/providers`,
    appBase,
    login: `${appBase}/login`,
    getStarted: `${appBase}/login?intent=vault`,
    providerLogin: `${appBase}/login?intent=services`,
    signIn: `${appBase}/signin`,
    signUp: `${appBase}/signup`,
    blogHome: "/blog",
    blogPublicUrl: "https://safevaultusa.com/blog",
    cliqloanHome: "https://www.cliqloan.com",
    safevaultHome: "https://safevaultusa.com",
    amitasoftHome: "https://www.amitasoft.com",
    social: SOCIAL,
  };
}
